import type { App } from 'vue';
import { appConfig } from '../providers/config';
import { getHubspotWindow } from '../composables/hubspot.types';

const isEnabled = (raw: string | undefined) => raw === 'true' || raw === '1';

export default {
  install(_app: App) {
    if (!isEnabled(appConfig.VITE_HUBSPOT_CHAT_ENABLED)) {
      return;
    }

    const hubId = appConfig.VITE_HUBSPOT_HUB_ID;
    if (!hubId) {
      return;
    }

    const hubspotWindow = getHubspotWindow();
    hubspotWindow.hsConversationsSettings = {
      ...hubspotWindow.hsConversationsSettings,
      loadImmediately: false,
    };

    const script = document.createElement('script');
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js-eu1.hs-scripts.com/${hubId}.js`;
    document.head.appendChild(script);
  },
};
